import { gql } from '@apollo/client';

export const CONTEXT_ACTION_QUERY = gql`
  fragment EnabledContextActionFragment on ContextAction {
    allRecordFields
    entityTypes
    id
    iocTypes
    name
    recordFields
    template
  }
  query EnabledContextActionsQueryOperation {
    contextActions(enabled: true) {
      hasNextPage
      total
      objects {
        ...EnabledContextActionFragment
      }
    }
    sumoLogicBaseUrl
    sumoLogicRegion
  }
`;
